import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { MdVisibility } from 'react-icons/md';

import { usePreviewMode } from '../hooks/use-preview-mode';

/**
 * Sticky banner with a toggle that lets reviewers/admins reveal unpublished
 * (draft) content. Renders nothing for users without the content-edit
 * capability, so members never see it.
 */
export const PreviewModeBanner: FC = () => {
  const { isPreview, canPreview, togglePreview } = usePreviewMode();

  if (!canPreview) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        px: 2,
        py: 1,
        mb: 2,
        borderRadius: '10px',
        border: '1px solid',
        borderColor: isPreview ? 'warning.main' : 'divider',
        bgcolor: isPreview ? 'warning.light' : 'background.paper',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <MdVisibility size={18} />
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
          {isPreview ? 'Preview mode — showing unpublished (draft) content' : 'Preview unpublished content'}
        </Typography>
      </Box>
      <Switch checked={isPreview} onChange={togglePreview} color="warning" size="small" />
    </Box>
  );
};
